<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
	<h2
		:class="
			cn(
				'm-0 font-[Inter,sans-serif] text-[clamp(30px,3vw,40px)] leading-[1.2] font-normal tracking-[-0.02em]',
				props.class
			)
		"
	>
		<slot />
	</h2>
</template>
